(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3282],{

/***/ 83171:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/redwood",
      function () {
        return __webpack_require__(46927);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 34507:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ RocketIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function RocketIcon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.8767 15.5158C19.8445 12.0469 22.8471 5.26536 21.0935 3.51175C19.3399 1.75814 12.5583 4.76075 9.08943 8.72856C6.8843 9.25328 2.4212 12.4164 3.06236 13.0576C3.38312 13.3784 5.11006 13.1972 7.03406 12.8721C6.93911 14.0457 7.32184 15.1959 8.36558 16.2397C9.40932 17.2834 10.5596 17.6661 11.7331 17.5712C11.4081 19.4952 11.2268 21.2222 11.5476 21.543C12.1887 22.1841 15.352 17.721 15.8767 15.5158ZM17.9115 8.10794C17.521 8.49844 16.8878 8.49844 16.4973 8.10794C16.1068 7.71745 16.1068 7.08423 16.4973 6.69373C16.8878 6.30323 17.521 6.30323 17.9115 6.69373C18.302 7.08423 18.302 7.71745 17.9115 8.10794Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M3.76938 20.8359C4.55038 21.6169 7.23094 20.2027 8.01202 19.4217C8.79311 18.6406 8.79302 17.3742 8.01202 16.5932C7.23103 15.8122 5.96468 15.8121 5.1836 16.5932C4.40252 17.3743 2.98839 20.0549 3.76938 20.8359Z",
                fill: "currentColor"
            })
        ]
    });
}


/***/ }),

/***/ 91881:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ BulletsLeft; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_sanity_sane_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27013);
/* harmony import */ var components_sanity_sane_block__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35547);



function BulletsLeft(props) {
    const { image , text , body , icons , background , imageWidth , bulletsProp  } = props;
    const { richText  } = body.filter((text)=>text.key === "bulletsLeftDescription")[0];
    const bullets = bulletsProp ? bulletsProp : [
        {
            id: 1,
            name: text.bulletsLeftFirstHeader,
            description: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: text.bulletsLeftFirstBody
            }),
            icon: icons[0]
        },
        {
            id: 2,
            name: text.bulletsLeftSecondHeader,
            description: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: text.bulletsLeftSecondBody
            }),
            icon: icons[1]
        }
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "py-8 overflow-hidden lg:py-14",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "relative max-w-xl px-4 mx-auto sm:px-6 lg:px-8 lg:max-w-7xl",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "lg:grid lg:grid-cols-2 lg:gap-8",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                className: "text-3xl font-extrabold text-gray-900 sm:text-4xl",
                                children: text.bulletsLeftHeader
                            }),
                            richText.map((text, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "max-w-3xl mt-3 text-lg text-gray-500",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_sanity_sane_block__WEBPACK_IMPORTED_MODULE_2__/* .SaneBlockChakra */ .C, {
                                        blocks: text
                                    })
                                }, index)),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mt-10 space-y-10",
                                children: bullets.map((item)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "relative",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "absolute flex items-center justify-center w-12 h-12 text-white rounded-md bg-clerk-blue",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(item.icon, {
                                                            className: "w-6 h-6",
                                                            "aria-hidden": "true"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                        className: "ml-16 text-xl font-medium leading-6 text-gray-900",
                                                        children: item.name
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "mt-2 ml-16 text-lg text-gray-500",
                                                children: item.description
                                            })
                                        ]
                                    }, item.id))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex flex-col items-center justify-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: background ? "my-5 lg:my-0 bg-white rounded-lg shadow-lg" : "my-5 lg:my-0",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "m-1 rounded-lg",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_sanity_sane_image__WEBPACK_IMPORTED_MODULE_1__/* .SaneImage */ .Q, {
                                    src: image.bulletsLeftImage,
                                    width: imageWidth
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 46927:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ RedwoodPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80943);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68793);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(92691);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(44320);
/* harmony import */ var _lib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58038);
/* harmony import */ var _components_integrations__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(91881);
/* harmony import */ var _components_solutions__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41662);
/* harmony import */ var _components_solutions__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83976);
/* harmony import */ var _components_solutions__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(49596);
/* harmony import */ var _components_solutions__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(78721);
/* harmony import */ var _components_solutions__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(94073);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34507);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(35547);






const { redwoodDocs  } = _lib__WEBPACK_IMPORTED_MODULE_1__/* .URLS */ .ns;
const signIn = "import { SignIn } from '@clerk/nextjs';\n  ...\n    return (\n      <>\n        <BackgroundImage />\n        <SignIn />\n      </>\n    );\n  ...";
const userProfile = "import { UserProfile } from '@clerk/nextjs';\n  ...\n    return (\n      <>\n        <CustomHeader />\n        <UserProfile />\n      </>\n    );\n  ...";
var __N_SSG = true;
function RedwoodPage(props) {
    const { image , text , body  } = props;
    const resources = [
        {
            title: "Documentation",
            description: body.find((text)=>text.key === "docsDescription"),
            icon: _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z
        },
        {
            title: "Guide",
            description: body.find((text)=>text.key === "blogDescription"),
            icon: _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z
        },
        {
            title: "Demo Repository",
            description: body.find((text)=>text.key === "pluginDescription"),
            icon: _components__WEBPACK_IMPORTED_MODULE_4__/* .RocketIcon */ .W
        }
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "mt-10",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_solutions__WEBPACK_IMPORTED_MODULE_5__/* .Header */ .h, {
                    title: text.headerTitle,
                    boldTitle: text.headerBoldTitle,
                    subheader: text.headerSubheader
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_solutions__WEBPACK_IMPORTED_MODULE_6__/* .GetStarted */ .F, {
                doc: redwoodDocs
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: "mt-12",
                id: "quote",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_solutions__WEBPACK_IMPORTED_MODULE_7__/* .SmallQuote */ .o, {
                        quote: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                "Clerk setup and Dashboard DX are SilkySmooth™ and left a great impression. It’s feature-rich and includes MFA, but none of that gets in the way of usability. I have no hesitation recommending developers give it a go — it’s as simple as typing",
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("code", {
                                    children: "redwood setup auth clerk"
                                })
                            ]
                        }),
                        name: text.quoteName,
                        title: text.quoteTitle,
                        image: image.quote
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_integrations__WEBPACK_IMPORTED_MODULE_8__/* .BulletsLeft */ .H, {
                        ...props,
                        imageWidth: 550,
                        icons: [
                            _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z,
                            _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "relative py-10",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "max-w-md px-4 mx-auto text-center sm:max-w-3xl sm:px-6 lg:px-8 lg:max-w-7xl",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: "text-base font-semibold tracking-wider uppercase text-clerk-blue",
                                    children: "Resources"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    className: "mt-2 text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl",
                                    children: "Get Started"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "mx-auto mt-5 text-xl text-gray-500 max-w-prose",
                                    children: text.resourcesDescription
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "mt-12",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3",
                                        children: resources.map((resource)=>{
                                            const Icon = resource.icon;
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "pt-6",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "flow-root h-full px-6 pb-8 bg-white shadow-xl rounded-2xl",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "-mt-6",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                        className: "inline-flex items-center justify-center p-3 rounded-md shadow-lg bg-clerk-blue",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {
                                                                            className: "w-6 h-6 text-white"
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                                    className: "mt-8 text-lg font-medium tracking-tight text-gray-900",
                                                                    children: resource.title
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    className: "mt-5 mb-2 text-base text-left text-gray-500",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_11__/* .SaneBlockChakra */ .C, {
                                                                        blocks: resource.description.richText
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            }, resource.title);
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_solutions__WEBPACK_IMPORTED_MODULE_12__/* .Code */ .E, {
                signIn: signIn,
                userProfile: userProfile
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "mt-32 mb-16",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_solutions__WEBPACK_IMPORTED_MODULE_13__/* .Powerful */ .Q, {})
            })
        ]
    });
}


/***/ }),

/***/ 68793:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72408);


function ClipboardCheckIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (ClipboardCheckIcon);

/***/ }),

/***/ 44320:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72408);


function LightningBoltIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M13 10V3L4 14h7v7l9-11h-7z"
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (LightningBoltIcon);

/***/ }),

/***/ 92691:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72408);


function TemplateIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z"
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (TemplateIcon);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6241,9385,5547,7008,9774,2888,179], function() { return __webpack_exec__(83171); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);